/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetDashboardPoliciesParams = zod.object({
	start: zod.string(),
	end: zod.string(),
	limit: zod.number().optional()
});

export type GetDashboardPoliciesParams = zod.input<typeof GetDashboardPoliciesParams>;
export type GetDashboardPoliciesParamsOutput = zod.output<typeof GetDashboardPoliciesParams>;
